import { Component, DestroyRef, inject, OnInit, viewChild, ChangeDetectionStrategy } from '@angular/core';
import { CategoryService } from '../category-page/category.service';
import type { CategoryTreeItemDto } from '@api/models';
import { HeadService } from '../../services/head.service';
import { LanguageService } from '../../services/language/language.service';
import { RouterLink } from '@angular/router';
import { HeaderComponent } from '../../components/header/header.component';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { SideCatalogMenuComponent } from '../../components/side-catalog-menu/side-catalog-menu.component';
import { BannerComponent } from '../../components/banner/banner.component';
import { RouterLinkWithLang } from '../../directives/router-link-with-lang/router-link-with-lang.directive';
import { InstaWidgetComponent } from '../../components/insta-widget/insta-widget.component';
import { RecentlyAddedProductsComponent } from '../../components/recently-added-products/recently-added-products.component';
import { PostsPreviewComponent } from './posts-preview/posts-preview.component';
import { RecentlyViewedProductsComponent } from '../../components/recently-viewed-products/recently-viewed-products.component';
import { FooterComponent } from '../../components/footer/footer.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'index',
  templateUrl: './index-page.component.html',
  styleUrls: ['./index-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    HeaderComponent,
    SideCatalogMenuComponent,
    BannerComponent,
    InstaWidgetComponent,
    RecentlyAddedProductsComponent,
    PostsPreviewComponent,
    RecentlyViewedProductsComponent,
    FooterComponent,
    TranslatePipe,
    RouterLink,
    RouterLinkWithLang,
  ],
})
export class IndexPageComponent implements OnInit {
  protected readonly categoryService = inject(CategoryService);
  private headService = inject(HeadService);
  private languageService = inject(LanguageService);
  private readonly destroyRef = inject(DestroyRef);

  readonly headerComp = viewChild(HeaderComponent);

  ngOnInit() {
    this.setMeta();
  }

  getCategoryImage(category: CategoryTreeItemDto): string {
    if (!category.m) {
      return '/assets/images/no-img.jpg';
    } else {
      return category.m;
    }
  }

  private setMeta() {
    const title = 'index.meta_title';
    const description = 'index.meta_description';
    this.languageService.getTranslation([title, description])
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: texts => {
          this.headService.setMeta({
            title: texts[title],
            description: texts[description],
            keywords: ''
          });
        }
      });
  }

  public openCatalogMenu(): void {
    this.headerComp().openCatalogFromSidebarHover();
  }
}
